import { RefObject, useEffect } from 'react';

export const useResizeObserver = (
    refs: RefObject<HTMLElement | null>[],
    onResize: () => void,
) => {
    useEffect(() => {
        const elements = refs.map((ref) => ref.current).filter((el): el is HTMLElement => el !== null);

        if (!elements.length) {
            return undefined;
        }

        onResize();

        if (window.ResizeObserver === undefined) {
            return undefined;
        }

        const observer = new ResizeObserver(onResize);

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, [refs, onResize]);
};
